import React, { useEffect, useRef } from "react";
import { ThreeEquirectRenderer } from "../../renderers/gl/ThreeEquirectRenderer";
// import { ThreeEquirectRenderer } from "../../renderers/gl/ThreeEquirectRendererPrevIter";
import { EquirectRenderer } from "../../renderers/gl/EquirectRenderer";
// 360 Video SingleView component with WebGL equirectangular rendering
export function SingleView({ video, view, overlays, bind, perf }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    return bind(canvasRef.current?.parentElement || null);
  }, [bind]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !video) return;

    let raf = 0;
    let stop = false;
    let lastTs = 0;
    let renderer = null;

    try {
      // Create the 360 equirectangular renderer
      renderer = new ThreeEquirectRenderer(canvas, video);
      // renderer = new EquirectRenderer(canvas, video);
      
      // Apply performance settings
      if (perf) {
        renderer.setPerf(perf);
      }

      const maxStep = 1000 / (perf?.maxFps ?? 60);

      const draw = (ts) => {
        if (stop) return;
        
        if (ts - lastTs < maxStep) {
          raf = requestAnimationFrame(draw);
          return;
        }
        
        lastTs = ts;
        // Convert degrees to radians for the renderer
        const yawRad = (view.yaw * Math.PI) / 180;
        const pitchRad = (view.pitch * Math.PI) / 180;
        const fovRad = (view.fov * Math.PI) / 180;
        
        renderer.render(yawRad, pitchRad, fovRad);
        raf = requestAnimationFrame(draw);
      };

      // Use requestVideoFrameCallback if available for better performance
      if (perf?.useRVFC && typeof video.requestVideoFrameCallback === 'function') {
        const cb = (_, __) => {
          if (stop) return;
          const yawRad = (view.yaw * Math.PI) / 180;
          const pitchRad = (view.pitch * Math.PI) / 180;
          const fovRad = (view.fov * Math.PI) / 180;
          renderer.render(yawRad, pitchRad, fovRad);
          video.requestVideoFrameCallback(cb);
        };
        video.requestVideoFrameCallback(cb);
        
        return () => {
          stop = true;
        };
      }

      // Fallback to requestAnimationFrame
      raf = requestAnimationFrame(draw);
      renderer.debug();
      return () => {
        stop = true;
        cancelAnimationFrame(raf);
      };
    } catch (error) {
      console.error('Failed to initialize 360 renderer:', error);
      // Fallback to regular video display
      return () => {
        stop = true;
        cancelAnimationFrame(raf);
      };
    }
  }, [video, view.yaw, view.pitch, view.fov, perf]);

  return (
    <div className="cam360-stage">
      <canvas ref={canvasRef} className="cam360-canvas" style={{transform: 'scaleX(-1)'}}/>
      {overlays}
    </div>
  );
}
